import React, {useContext} from "react";
import UserContext from '../../contexts/user';
import {ICollectionOverview} from "../../tevapi/interfaces";
import {Button, Dropdown, MenuProps} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AddToCollection, AssignTOIButton, CreateCollection, RemoveItems} from "../forms/collections";
import {vettingLinkList} from "../vetting/vetting-select";
import {MutateSelection} from "./mutation";


interface ITableMenu {
  collection: ICollectionOverview;
  selection: Array<number>;
};


export const TableMenu: React.FC<ITableMenu> = ({collection, selection}) => {
  // Construct menu in respect to user's administration status
  const user = useContext(UserContext);

  const menuItems: MenuProps["items"] = [];

  if (user.is_staff) {
    menuItems.push({
      key: 'toi-management',
      type: 'group',
      label: "TOI Management",
      children: [
        {
          key: 'assign-tois',
          label: (
            <AssignTOIButton collection_pk={collection.pk} />
          )
        }
      ]
    });
    menuItems.push({
      key: 'vetting-management',
      type: 'group',
      label: 'Vetting Management',
      children: [{
        key: 'start-vetting',
        label: 'Start Vetting',
        children: vettingLinkList(collection),
      },
      {
        key: 'end-vetting',
        label: (
          "Stop Vetting"
        ),
        disabled: true,
      },
      ],
    });
    menuItems.push({
      key: 'selection-operations',
      type: 'group',
      label: "With Selection",
      children: [{
        key: 'subcollection',
        disabled: selection.length == 0,
        label: (
          <CreateCollection
            parent={collection.pk}
            selection={selection}
          />
        ),
      }, {
        key: 'add_to_collection',
        disabled: selection.length == 0,
        label: (
          <AddToCollection selection={selection} />
        ),
      }, {
        key: 'mutate',
        disabled: selection.length == 0,
        label: <MutateSelection selection={selection} />
      },
      {
        key: 'remove',
        disabled: selection.length == 0,
        label: (
          <RemoveItems
            collection_pk={collection.pk}
            selection={selection}
          />
        ),
      }
      ]
    });
  }

  return (
    <Dropdown
      menu={{items: menuItems}}
      disabled={(menuItems.length < 1)}
    >
      <Button>
        <FontAwesomeIcon icon="fa-solid fa-gear"/>
      </Button>
    </Dropdown>
  );
};
